import React, { Fragment, memo, useCallback, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { MVRYardstik } from 'src/components/mvr/MVRYardstik'
import { MVRManualUpload } from 'src/components/mvr/MVRManualUploadForm'
import { MVRCollectDataStep } from 'src/interfaces/collectData'
import { MVRSelectOption } from './MVRSelectOption'
import { MVROption, MVROptionType } from './types'
import { yardstikOption, manualOption, skipOption } from './constants'

const MVRComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep) as MVRCollectDataStep

  const [selectedOptionType, setSelectedOptionType] = useState<MVROptionType | undefined>(undefined)

  const options = useMemo(() => {
    const res: MVROption[] = []

    if (currentStep.metadata?.enableProvider) {
      res.push(yardstikOption)
    }

    if (currentStep.metadata?.enableManualUpload) {
      res.push(manualOption)
    }

    if (currentStep.optional) {
      res.push(skipOption)
    }

    return res
  }, [currentStep.metadata, currentStep.optional])

  const selectedOption = useMemo(() => {
    if (options.length === 1) {
      return options[0].value
    }

    return selectedOptionType
  }, [options, selectedOptionType])

  const handleBackToMainPage = useCallback(() => {
    setSelectedOptionType(undefined)
  }, [])

  const onBack = !!selectedOption && options.length > 1 ? handleBackToMainPage : undefined

  return (
    <Fragment>
      {(!selectedOption || selectedOption === 'skip') && (
        <MVRSelectOption
          options={options}
          selectedOption={selectedOption}
          onSelect={setSelectedOptionType}
        />
      )}
      {selectedOption === 'yardstik' && <MVRYardstik onBack={onBack} />}
      {selectedOption === 'manual' && (
        <MVRManualUpload
          onBack={onBack}
          hideStepsCounter={options.length > 1}
          isYardstikEnabled={options.some((item) => item.value === 'yardstik')}
        />
      )}
    </Fragment>
  )
}

export const MVR = memo(MVRComponent)
